import React from 'react';
import { FeaturesBlockStyled, List, ListItem, Figure } from './styled';
import Grid from '../Grid';

const featuresList = [
  {
    icon: 'https://cdn.auth0.com/website/universal-login/touch-icon.svg',
    text: 'Single Sign On'
  },
  {
    icon: 'https://cdn.auth0.com/website/universal-login/lock-icon.svg',
    text: 'Security'
  },
  {
    icon: 'https://cdn.auth0.com/website/universal-login/device-phone.svg',
    text: 'Best practice for mobile <br> applications'
  },
  {
    icon: 'https://cdn.auth0.com/website/universal-login/deshboard-icon.svg',
    text: 'Centralized Feature <br> Management and UX'
  },
  {
    icon: 'https://cdn.auth0.com/website/universal-login/domain-icon.svg',
    text: 'Custom Domains'
  },
  {
    icon: 'https://cdn.auth0.com/website/universal-login/user-exp-icon.svg',
    text: 'Customize Login'
  }
];

const FeaturesBlock = () => {
  return (
    <FeaturesBlockStyled>
      <Grid>
        <List>
          {featuresList.map((featuresItem, i) => (
            <ListItem key={i}>
              <Figure>
                <img src={featuresItem.icon} />
                <figcaption dangerouslySetInnerHTML={{ __html: featuresItem.text }} />
              </Figure>
            </ListItem>
          ))}
        </List>
      </Grid>
    </FeaturesBlockStyled>
  );
};

export default FeaturesBlock;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/FeaturesBlock/FeaturesBlock.js